<template>
    <CustomHeader :text="$t('profile.fundHistory')" :is-popup-close-back-icon="true" @close-popup="navToback" />
    <div class="container">
        <van-tabs v-model:active="active" sticky :ellipsis="false" @click-tab="onClickTab">
            <van-tab v-for="(item, index) in dataSet.tabList" :key="index" :title="$t(item.name)" :name="item.id">
                <div id="subTabContainer">
                    <van-tabs v-model:active="subActive" sticky :ellipsis="false" @click-tab="onClickSubTab">
                        <van-tab v-for="(item, index) in dataSet.subTabList" :key="index" :title="$t(item.name)"
                            :name="item.id">
                        </van-tab>
                    </van-tabs>
                </div>
                <div class="content">
                    <div v-if="dataSet?.dataLog?.length > 0">
                        <!-- Recharge -->
                        <div v-if="item.id == 2" class="rechargeDataSet">
                            <div v-for="(item, index) in dataSet?.dataLog" :key="index">
                                <CustomDataRow :card-data="item" :status="setRechargeStatus(item.status)"
                                    :class="index % 2 === 0 ? 'row-dark' : 'row-light'" />
                            </div>
                        </div>
                        <!-- Withdraw -->
                        <div v-if="item.id == 3" class="rechargeDataSet">
                            <div v-for="(item, index) in dataSet?.dataLog" :key="index">
                                <CustomDataRow :card-data="item" :status="setWithdrawStatus(item.status)"
                                    :class="index % 2 === 0 ? 'row-dark' : 'row-light'" />
                            </div>
                        </div>
                        <!-- Flow log -->
                        <div v-if="item.id == 1" class="flowLogDataSet">
                            <div v-for="(item, index) in dataSet?.dataLog" :key="index">
                                <FlowLogCard :card-data="item" :class="index % 2 === 0 ? 'row-dark' : 'row-light'" />
                            </div>
                        </div>
                        <van-row v-if="dataSet.total > dataSet.pageSize * dataSet.pageNum">
                            <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                                    @click="getNextPageList"></van-col>
                        </van-row>
                        <div v-else class="no_more">{{ $t('common.NoMoreData') }}</div>
                    </div>
                    <div v-else>
                        <NoData />
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import CustomHeader from '../components/common/customHeader.vue';
import { FundHistoryData, setRechargeStatus, setWithdrawStatus } from '@/view/fundHistory/supportScript';
import CustomDataRow from './components/customDataRow.vue';
import NoData from '../components/common/noData.vue';
import FlowLogCard from './components/flowLogCard.vue';
import { useRoute, useRouter } from 'vue-router';
const props = defineProps<{
    dataSet: FundHistoryData
}>()
const route = useRoute()
const router = useRouter()
const active = ref(props.dataSet.active);
const subActive = ref(props.dataSet.subActive);

const emits = defineEmits(['onClickTab', 'getNextPageList', 'onClickSubTab'])

const onClickTab = (active: any) => {
    emits('onClickTab', active)
}
const onClickSubTab = (active: any) => {
    emits('onClickSubTab', active)
}
const getNextPageList = () => {
    emits('getNextPageList')
}
const navToback = () => {
    if (Number(route.query.tabIndex) == 0) {
        router.replace({ path: '/sd-topup', query: { tabIndex: 0 } })
    } else if (Number(route.query.tabIndex) == 1) {
        router.replace({ path: '/sd-withdraw', query: { tabIndex: 1 } })
    } else {
        router.go(-1)
    }

}
onMounted(() => {
    if (route.query.tabIndex) {
        active.value = Number(route.query.tabIndex) === 0 ? 2 : 3
    }
})
</script>
<style scoped>
.container {
    padding: 70px 0;

}


.container>>>.van-tabs__wrap {
    backdrop-filter: blur(8px);
    border-bottom: 1.5px solid #4f3519;
    height: 35px;
}

.container>>>.van-tabs__nav {
    background: transparent;
    padding: 0 15px;
}

.container>>>.van-tab {
    color: rgba(255, 255, 255, 0.85);
    font-weight: 700;
    border-radius: 10px 10px 0 0;
    font-size: 13px;
    margin: 0 3px;
    padding: 0 10px;
}

.container>>>.van-tab.van-tab--active {
    color: rgba(0, 0, 0, 0.85);
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    font-weight: 700;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

:deep(.van-tabs__wrap),
:deep(.van-tabs__scroll),
:deep(.van-tabs__nav),
:deep(.van-tabs__nav--line),
:deep(.van-tab) {
    scrollbar-width: none !important;
    /* Firefox */
}

:deep(.van-tabs__wrap::-webkit-scrollbar),
:deep(.van-tabs__scroll::-webkit-scrollbar),
:deep(.van-tabs__nav::-webkit-scrollbar),
:deep(.van-tabs__nav--line::-webkit-scrollbar),
:deep(.van-tab::-webkit-scrollbar) {
    display: none !important;
    /* Chrome, Safari, Edge */
}

.content {
    color: #fff;
    padding: 15px;
    margin: 0 15px;
    background-color: #322316;
    min-height: 75vh;
}

.top_card {
    background: #3D2E22;
    border: 0.5px solid rgba(221, 122, 51, 0.25);
    border-radius: 10px;
    padding: 15px;
}

.card_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 11.75px;
    padding: 2.5px 0;
}

.card_text span {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.65);
}

.sub_text {
    color: rgba(255, 255, 255, 0.45);
    text-align: center;
    padding: 15px 70px;
    font-size: 12px;
}

.no_more {
    color: #969799;
    display: flex;
    justify-content: center;
    padding: 10px;
    font-size: 14px;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 30px;
    transform: rotate(-90deg);
}

:deep(.van-tabs__wrap),
:deep(.van-tabs__scroll),
:deep(.van-tabs__nav),
:deep(.van-tabs__nav--line),
:deep(.van-tab) {
    scrollbar-width: none !important;
    /* Firefox */
}

:deep(.van-tabs__wrap::-webkit-scrollbar),
:deep(.van-tabs__scroll::-webkit-scrollbar),
:deep(.van-tabs__nav::-webkit-scrollbar),
:deep(.van-tabs__nav--line::-webkit-scrollbar),
:deep(.van-tab::-webkit-scrollbar) {
    display: none !important;
    /* Chrome, Safari, Edge */
}

#subTabContainer :deep(.van-tab) {
    height: auto;
    background: transparent;
    min-width: 80px;
}

#subTabContainer :deep(.van-tab):hover {
    border-radius: 5px 5px 0 0;
    background: #ffffff07;
}

#subTabContainer :deep(.van-tab.van-tab--active) {
    background: #ffdeab !important;
    border-radius: 5px;
    margin: 0;
    min-width: 80px;
}

#subTabContainer :deep(.van-tab--active .van-tab__text) {
    color: #000 !important;
}

#subTabContainer :deep(.van-tabs__wrap) {
    border-bottom: unset;
    padding: 10px 10px 0;
    margin-bottom: 15px;
}
</style>